import { Media } from "reactstrap";
import { NavLink as Link } from 'react-router-dom';
import icon_members from '../../../assets/img/IconMembers.svg';
import icon_team_arrow_right from '../../../assets/img/icon-team-arrow-right.svg';

const TeamItem = (props) => {
    const { item } = props;

    return (
        <>
        <div key={item.id} className="team-item">
            <Link to={`/teams/${item.id}`} className="media text-reset text-decoration-none border rounded align-items-center">
                <Media left className="mr-2">
                    <img className="media-object rounded-circle" width="36" height="36" src={item.image || icon_members} alt={item.name}/>
                </Media>
                <Media body>
                    <Media heading tag="h5" className="text-reset mb-0">{item.name}</Media>
                    <p className="line-height-normal mb-0">
                        <span className={`${(!item.members) ? 'text-danger' : 'text-muted'} small`}>{item.members} members</span>
                    </p>
                </Media>
                <img className="talents-icon-arrow my-auto mr-1" src={icon_team_arrow_right} width="16" height="auto" alt="Arrow" />
            </Link>
        </div>
        </>
    )}
export default TeamItem;